import firebase from 'firebase'

let firebaseConfig = {
  apiKey: 'AIzaSyDr6QbGXJEL3XrqxIVyMIF2QDylQrbjaVo',
  authDomain: 'bpx-app.firebaseapp.com',
  databaseURL: 'https://bpx-app.firebaseio.com',
  projectId: 'bpx-app',
  storageBucket: 'bpx-app.appspot.com',
  messagingSenderId: '1027715186378',
  appId: '1:1027715186378:web:d23de23db9371551dabe33',
  measurementId: 'G-K04TXFX2QZ'
}

const fireApp = firebase.initializeApp(firebaseConfig)

const { Timestamp } = firebase.firestore
export { fireApp, Timestamp }
